import ConstantsModule from "./constants.module";

ConstantsModule.constant("APP_CATEGORY", {
    SETUP: "SETUP",
    DASHBOARDS_AND_TRACKERS: "DASHBOARDS & TRACKERS",
    LISTS: "LISTS",
    SCHEDULES_AND_TIMELINES: "SCHEDULES & TIMELINES",
    RESOURCES: "RESOURCES",
});
